// EngineRefreshAdapter.js

export function buildRefreshSpecFromBaseService({
  baseItemsUri,   // e.g., window.configData.API_URIS["CORE"] + "/Items"
  appName,        // e.g., "CORE" | "Convoke"
  apiName,        // e.g., "DashboardDataset"
  operationType,  // e.g., "REFRESH_DATASET_DATA"
  id,             // dataset _id
  item,           // optional POST body
  queryParams,    // optional querystring
  processorType,  // optional
}) {


  let url = `${baseItemsUri}/${apiName}${id ? `/${id}` : ""}`;
  if (queryParams) {
    const qs = new URLSearchParams(queryParams).toString();
    if (qs) url += `?${qs}`;
  }

  const headers = {
    "c-dx-operation": operationType,
    "c-dx-operation-format": "Metadata",
  };
  if (processorType) headers["c-dx-processor-type"] = processorType;

  // Auth & app headers mirroring your BaseService
  const token = sessionStorage.getItem("CoreAuth")
    ? JSON.parse(sessionStorage.getItem("CoreAuth"))["Access"]
    : null;
  const cdxClientId = sessionStorage.getItem("client-impersonation");

  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (cdxClientId) headers["C-DX-Client-Id"] = cdxClientId;
  headers["C-DX-App-Id"] = (window.configData?.APP_IDS?.[appName] ?? appName);

  return {
    request: {
      url,
      method: "POST",
      headers,
      body: item ?? null,
    },
  };
}
